module.exports = __webpack_public_path__ + "static/media/SlatePro-Light.70e4fe51.otf";